import { evidenceLabelMap, type CaseItem } from '@/mocks/cases';

const iconMap: Record<string, string> = {
  audio: 'ri-mic-line',
  video: 'ri-film-line',
  contract: 'ri-file-paper-2-line',
  transfer: 'ri-exchange-dollar-line',
};

export default function EvidenceList({ items }: { items: CaseItem['evidenceItems'] }) {
  return (
    <ul className="space-y-4">
      {items.map((item) => (
        <li key={item.title} className="rounded-lg border border-background-200 bg-background-50 p-5">
          <div className="flex items-start gap-4">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
              <i className={`${iconMap[item.key]} text-xl`}></i>
            </span>
            <div className="flex-1">
              <div className="flex flex-wrap items-center gap-2">
                <h3 className="font-heading text-base font-semibold text-foreground-950">{item.title}</h3>
                <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-800">
                  {evidenceLabelMap[item.key]}
                </span>
              </div>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              <p className="mt-2 flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-information-line"></i>
                {item.meta}
              </p>
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}